import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

const ResponsiveLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isTimeline = location.pathname === '/' || location.pathname.startsWith('/timeline');

  return (
    <div className={`responsive-layout-wrapper ${isTimeline ? 'timeline-layout' : 'subpage-layout'}`}>
      {children}
      <style>{`
        .responsive-layout-wrapper {
          box-sizing: border-box;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          transition: padding 0.3s ease;
          width: 100%;
        }
        
        .timeline-layout {
          max-width: none;
          margin: 0;
          padding: 0;
          padding-top: 60px; /* 헤더 fixed(60px) 고려 */
          background: var(--background);
        }
        
        .subpage-layout {
          max-width: 1440px;
          margin: 0 auto;
          padding: 32px;
          padding-top: 84px; /* 헤더(60px) + 여백(24px) */
          background: var(--background);
          color: var(--text-primary);
          width: 100%;
        }

        .subpage-layout table,
        .subpage-layout th,
        .subpage-layout td {
          color: inherit;
        }
        
        @media (max-width: 768px) {
          .subpage-layout {
            padding: 12px;
            padding-top: 72px; /* 모바일 헤더(60px) + 여백(12px) */
          }
        }
      `}</style>
    </div>
  );
};

export default ResponsiveLayout;
